import { connect } from 'react-redux';
import { compose } from 'redux';
import { publishHeaderHeight } from '../redux/store/ui/dimensions';
import { DimensionsState, State } from '../@types';

export type Props = {
  dimensions: DimensionsState;
  publishHeaderHeight: typeof publishHeaderHeight;
};

const withDimensions: any = compose(
  connect(
    ({ ui: { dimensions } }: State) => ({
      dimensions,
    }),
    {
      publishHeaderHeight,
    }
  )
);
export default withDimensions;
